import { render, staticRenderFns } from "./SingleImage.vue?vue&type=template&id=0969eea4&scoped=true&"
import script from "./SingleImage.vue?vue&type=script&lang=ts&"
export * from "./SingleImage.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=0969eea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0969eea4",
  null
  
)

export default component.exports